/*
 *
 *  A module for toggling component state with css classes.
 *
 *  Pass the css class of the target element and the css class you wish
 *  to toggle
 *
 *  If the linkElem is an anchor link we will disable it on mobile
 *  so we can toggle the element into view
 *
 *  Implementation:
 *
 *  import { toggleState } from 'path-to-file.ts';
 *  toggle( '[data-target-nav]', 'targetNav','active' );
 *
 *  <div data-target-nav="[data-link-nav]"/></div>
 *
 *  <nav data-link-nav></nav>
 *
 */

export function toggleState(selector: string, datasetValue: string, active: string) {
  const targetElems: NodeListOf<HTMLElement> = document.querySelectorAll(selector);

  targetElems.forEach((targetElem) => {
    let linkElems: NodeListOf<HTMLElement> = document.querySelectorAll(targetElem.dataset[datasetValue]);

    linkElems.forEach((link) => {
      link.addEventListener("click", () => {
        targetElem.classList.toggle(active);
      });
    });
  });
}
